'use client';

import { ReactNode, useState } from 'react';
import { useUserContext } from '@instamenu/context-user';
import { Avatar } from '../avatar/avatar';
import { Box } from '../box/box';
import { Text } from '../text/text';
import { menuStyles, nameStyles } from './user-menu.css';
import { usePathname } from 'next/navigation';
import { SignIn } from './sign-in';
import { UserMenuLink } from './user-menu-link';
import { observer } from 'mobx-react-lite';
import { Dropdown, DropdownContainer } from '../dropdown/dropdown';
import { useLocale } from '@instamenu/context-i18n';

export const UserMenu = observer(function UserMenu({
  children,
  hasDropdown = true,
}: {
  children?: ReactNode;
  hasDropdown?: boolean;
}) {
  const { isAuthenticated, user, signOut, ready, showModal, setShowModal } = useUserContext();
  const [visible, setVisible] = useState(false);
  const pathname = usePathname();
  const { i18n } = useLocale();

  const handleSignOut = () => {
    signOut();
    if (pathname.includes('/locations')) window.location.reload();
    setShowModal(false);
    setVisible(false);
  };

  if (!isAuthenticated || !user)
    return <SignIn ready={ready} setShowModal={setShowModal} showModal={showModal} />;

  return (
    <DropdownContainer
      onDismiss={() => {
        setVisible(false);
        setShowModal(false);
      }}
    >
      <Box data-id="user-menu" className={menuStyles} onClick={() => setVisible(!visible)}>
        <Avatar user={user} />
        <Box className={nameStyles}>
          <Text variant="caption1">{user.name}</Text>
        </Box>
      </Box>
      {hasDropdown && (
        <Dropdown visible={visible}>
          {children}
          <UserMenuLink onClick={handleSignOut}>{i18n.t('header.signOut')}</UserMenuLink>
        </Dropdown>
      )}
    </DropdownContainer>
  );
});
